import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { ClientNotificationHandlerService, FileObject } from '@thehubz/client/core';
import { AnyType } from '@thehubz/shared/model';

@Component({
  selector: 'sp-file-drag-n-drop',
  templateUrl: './file-drag-n-drop.component.html',
  styleUrls: ['./file-drag-n-drop.component.scss'],
})
export class FileDragNDropComponent {
  @Output() uploadedFiles = new EventEmitter<FileObject[]>();
  @Input() progress = 0;
  @Input() uploadCaption = '';
  @Input() currentUploadFileName!: string;
  @Input() multipleFile = true;
  @Input() required = false;
  files: FileObject[] = [];
  listOfFiles: string[] = [];
  dragOverState = false;
  uploadInProgress = false;

  @ViewChild('fileDropRef') fileDropRef!: ElementRef;

  constructor(private clientNotificationHandlerService: ClientNotificationHandlerService) {}

  fileHandler(event: AnyType) {
    const target = event.fileDropped ? event.files : (event.target as HTMLInputElement)?.files;
    if (target) {
      this.prepareFilesList(target);
    }
  }

  private prepareFilesList(files: FileList) {
    let index = 0;
    for (const item of files) {
      const selectedFile = files[index];
      const fileExist = this.listOfFiles.indexOf(selectedFile.name);
      if (fileExist === -1) {
        if (!this.multipleFile) {
          this.files = [];
        }
        this.files.push({ file: item, key: item.name, name: item.name, uploaded: false, uploading: false });
        this.listOfFiles.push(selectedFile.name);
      } else {
        this.clientNotificationHandlerService.successNotification(`File with name ${item.name} already selected`, 'info');
      }
      index++;
    }
    this.uploadedFiles.emit(this.files);
  }

  clear(): void {
    this.files = [];
    this.listOfFiles = [];
    this.fileDropRef.nativeElement.value = '';
  }

  onDragOver() {
    this.dragOverState = true;
  }

  onDragOut() {
    this.dragOverState = false;
  }
}
